import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetCurbsideOversized extends AbstractProductType {

  name = 'valet_curbside_oversized'
  title = 'Valet Curbside Oversized'

  curbside = true
  oversized = true
  valet = true
  format = ProductTypeFormat.Uncovered

}
